// Theme pages: one canonical facility crossed with one region.
//
// The reason these exist is that nobody types "beach club Sicily". People type
// "beach with dog Sicily" or "beach club with pool Ibiza". We already hold the
// answer for 774 of 827 clubs; until now it was only reachable as a filter
// chip, which no search engine can land on.
//
// Only distinctive facilities get a page. A bar sits on 720 of 827 clubs and a
// restaurant on 713, so "beach clubs with a bar" is the whole catalogue with a
// different heading: a page that answers nothing and competes with /clubs.

export const THEMES = [
  "kids_area",
  "pool",
  "pets_allowed",
  "accessible",
  "water_sports",
  "dj",
  "cabanas",
  "parking",
] as const;

export type Theme = (typeof THEMES)[number];

// URL slugs, deliberately not the internal keys: "dog-friendly" is what a
// person would type and what a link should read. English everywhere, like the
// club and region slugs, so /nl/theme/dog-friendly/sicily stays one page in six
// languages rather than six URLs to keep in step.
const SLUGS: Record<Theme, string> = {
  kids_area: "family-friendly",
  pool: "with-pool",
  pets_allowed: "dog-friendly",
  accessible: "accessible",
  water_sports: "water-sports",
  dj: "music",
  cabanas: "cabanas",
  parking: "with-parking",
};

const BY_SLUG = new Map<string, Theme>(
  (Object.entries(SLUGS) as [Theme, string][]).map(([k, s]) => [s, k]),
);

export function themeSlug(theme: Theme): string {
  return SLUGS[theme];
}

export function themeFromSlug(slug: string): Theme | null {
  return BY_SLUG.get(slug) ?? null;
}

// Below this a page is a list of two clubs and a heading. We spent a week
// getting 676 club pages out of noindex; the last thing to do now is manu-
// facture a hundred pages that deserve to be there.
export const MIN_CLUBS_PER_THEME_PAGE = 5;
